<template>
  <VueCtkDateTimePicker :range="false" v-model="value"
    id="setDate"
    class="getDate"
    :only-date="true"
    :color="'var(--color-pri)'"
    :no-label="true"
    :auto-close="true"
    :locale="'zh-tw'"
    :input-size="size?size:'md'"
    :format="'YYYY-MM-DD'"
    :formatted="'YYYY-MM-DD'"
    :label="'請選擇日期'"/>
</template>

<script>
export default {
  props: ['defaultValue', 'size', 'color'],
  data () {
    return {
      value: null
    }
  },
  mounted () {
    this.value = this.defaultValue
  },
  watch: {
    defaultValue () {
      this.value = this.defaultValue
    },
    value () {
      if (this.value !== this.defaultValue) {
        console.log('value Change date')
        this.$emit('input', this.value)
      }
    }
  }
}
</script>

<style lang="scss">
#setDate-wrapper {
  width: 290px;
  &>.field {
    .field-clear-button {
      right: 40px;
    }
    &>input[type=text] {
      height: 40px;
      border: 1px solid var(--color-pri);
      font-size: 16px!important;
      letter-spacing: .1em;
    }
    &::after {
      content: '';
      display: inline-block;
      width: 20px;
      height: 20px;
      background-color: var(--color-pri);
      mask-image: url(./svg/icon/celender.svg);
      position: absolute;
      right: 10px;
    }
  }
  #setDate-input {
    padding-right: 66px;
    height: 40px;
    font-size: 20px!important;
    color: #676767;
  }
}
</style>
